// AUTO-GENERATED - DO NOT EDIT MANUALLY

import { BookingRuleType } from './enums.gen';
import { hydratePaxRule, type PaxRule, type PaxRuleApiResponse } from './paxRule.gen';
import { hydrateOfferRule, type OfferRule, type OfferRuleApiResponse } from './offerRule.gen';
import { hydrateProductRule, type ProductRule, type ProductRuleApiResponse } from './productRule.gen';
import { hydrateActivityRule, type ActivityRule, type ActivityRuleApiResponse } from './activityRule.gen';
import { hydrateSessionRule, type SessionRule, type SessionRuleApiResponse } from './sessionRule.gen';
import { hydrateValidityDatesRule, type ValidityDatesRule, type ValidityDatesRuleApiResponse } from './validityDatesRule.gen';
import { hydratePriceRule, type PriceRule, type PriceRuleApiResponse } from './priceRule.gen';
import { hydrateCustomerBookingCountRule, type CustomerBookingCountRule, type CustomerBookingCountRuleApiResponse } from './customerBookingCountRule.gen';

export type BookingRuleApiResponse =
	| PaxRuleApiResponse
	| OfferRuleApiResponse
	| ProductRuleApiResponse
	| ActivityRuleApiResponse
	| SessionRuleApiResponse
	| ValidityDatesRuleApiResponse
	| PriceRuleApiResponse
	| CustomerBookingCountRuleApiResponse;

export type BookingRule =
	| PaxRule
	| OfferRule
	| ProductRule
	| ActivityRule
	| SessionRule
	| ValidityDatesRule
	| PriceRule
	| CustomerBookingCountRule;

export function hydrateBookingRule(data: BookingRuleApiResponse): BookingRule {
	switch (data.type) {
		case BookingRuleType.Pax:
			return hydratePaxRule(data as PaxRuleApiResponse);
		case BookingRuleType.Offer:
			return hydrateOfferRule(data as OfferRuleApiResponse);
		case BookingRuleType.Product:
			return hydrateProductRule(data as ProductRuleApiResponse);
		case BookingRuleType.Activity:
			return hydrateActivityRule(data as ActivityRuleApiResponse);
		case BookingRuleType.Session:
			return hydrateSessionRule(data as SessionRuleApiResponse);
		case BookingRuleType.ValidityDates:
			return hydrateValidityDatesRule(data as ValidityDatesRuleApiResponse);
		case BookingRuleType.Price:
			return hydratePriceRule(data as PriceRuleApiResponse);
		case BookingRuleType.CustomerBookingCount:
			return hydrateCustomerBookingCountRule(data as CustomerBookingCountRuleApiResponse);
	}
}